// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Hra-z","fadeIn":"Ira-z","delay":"Jra-z","recommendedSizeTooltip":"Kra-z"};